import React from 'react';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Email from '@material-ui/icons/Email';
import InfoIcon from '@material-ui/icons/Info';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useStyles } from '../../views/master-sheet-styles';
import AddRepairDialog from '../Repairs/AddRepairDialog';
import RepairDialog from '../Repairs/RepairModal';
import MasterSheetRepairsCheckPhotos from '../Repairs/RepairsCheckPhotosDialog';
import { Show } from 'components/Show';
import { maskDate } from '../../utils/maskDate';
import { getAddContractorsBlocked } from '../../utils/getAddContractorsBlocked';
import { EmailManagementDialog } from '../EmailManagementDialog';
import InfoDialog from 'components/InfoDialog';

interface DesktopRepairsViewProps {
  logic: any;
}

export const DesktopRepairsView: React.FC<DesktopRepairsViewProps> = ({
  logic,
}) => {
  const classes = useStyles();

  const {
    repairs,
    hasRepairs,
    poReleasedInfoOpen,
    setPoReleasedInfoOpen,
    showRepairModal,
    setShowRepairModal,
    showAddRepairModal,
    setShowAddRepairModal,
    repair,
    setRepair,
    openCheckPhotosModal,
    setOpenCheckPhotosModal,
    isShowView,
    title,
    photos,
    loadingBuilderSupervisorEmail,
    hasPhotos,
    setHasPhotos,
    emailManagementOpen,
    setEmailManagementOpen,
    emailRepairId,
    setEmailRepairId,
    scroll,
    subdivisionBuilderSupervisors,
    canSendEmailClient,
    canCreateRepair,
    handleSendMail,
    onAddRepair,
    handleUploadClick,
    getRepairButtonText,
    handleRepairActionClick,
    theJob,
    refreshRepairs,
    setJob,
  } = logic;

  return (
    <Box px={3}>
      <Box display="flex" justifyContent="space-between" my={4}>
        <Typography className={classes.titleFont}>Repairs</Typography>
        {canCreateRepair && (
          <Button
            variant="contained"
            color="primary"
            size="large"
            className={classes.buttonRepairs}
            onClick={() => setShowAddRepairModal(true)}
          >
            Add Repair
          </Button>
        )}
      </Box>
      <div ref={scroll} />
      <Box width="100%">
        {hasRepairs && (
          <Box width="100%" display="flex">
            <Box width="100%">
              <Typography className={classes.titleFont}>
                Service Type
              </Typography>
            </Box>
            <Box width="100%">
              <Typography className={classes.titleFont}>Description</Typography>
            </Box>
            <Box width="100%">
              <Typography className={classes.titleFont}>Date</Typography>
            </Box>
            <Box width="100%">
              <Typography className={classes.titleFont}>PO Total $</Typography>
            </Box>
            <Show condition={canSendEmailClient}>
              <Box width="100%">
                <Typography className={classes.titleFont}>
                  Email Management
                </Typography>
              </Box>
            </Show>
            <Box width="100%">
              <Typography className={classes.titleFont}>Uploads</Typography>
            </Box>
          </Box>
        )}
        {repairs.map((repair, i) => {
          const { description, repairDate, poTotal, text, hasPhotos } = repair;

          const isAddContractorsBlocked = getAddContractorsBlocked(repair);
          const buttonText = getRepairButtonText(repair);

          return (
            <Box key={i} borderTop="1px solid black" py={3} mt={3}>
              <Box width="100%" display="flex" my={1}>
                <Box
                  display="flex"
                  alignItems="center"
                  gridColumnGap={2}
                  width="100%"
                >
                  <Typography className={classes.bigText}>
                    {description}
                  </Typography>
                  <Show condition={isAddContractorsBlocked}>
                    <IconButton onClick={() => setPoReleasedInfoOpen(true)}>
                      <InfoIcon color="error" />
                    </IconButton>
                  </Show>
                </Box>
                <Box width="100%">
                  <Typography className={classes.bigText}>{text}</Typography>
                </Box>
                <Box width="100%">
                  <Typography className={classes.bigText}>
                    {maskDate(repairDate)}
                  </Typography>
                </Box>
                <Box width="100%">
                  <Typography className={classes.bigText}>{poTotal}</Typography>
                </Box>
                <Show condition={canSendEmailClient}>
                  <Box width="100%">
                    <Typography className={classes.bigText}>
                      <IconButton
                        disabled={loadingBuilderSupervisorEmail}
                        onClick={async () => {
                          setRepair(repair);
                          setEmailRepairId(repair?.id);
                          setHasPhotos(hasPhotos);
                          setEmailManagementOpen(true);
                        }}
                      >
                        {repair?.id === emailRepairId &&
                        loadingBuilderSupervisorEmail ? (
                          <CircularProgress size={30} />
                        ) : (
                          <Email className={classes.iconsUpload} />
                        )}
                      </IconButton>
                    </Typography>
                  </Box>
                </Show>
                <Box width="100%">
                  {hasPhotos ? (
                    <Typography className={classes.titleFont}>
                      <IconButton onClick={() => handleUploadClick(repair)}>
                        <CloudUploadIcon className={classes.iconsUpload} />
                      </IconButton>
                    </Typography>
                  ) : null}
                </Box>
              </Box>
              <Box display="flex" justifyContent="flex-end">
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  className={classes.buttonRepairs}
                  onClick={() => handleRepairActionClick(repair)}
                >
                  {buttonText}
                </Button>
              </Box>
            </Box>
          );
        })}
      </Box>
      <AddRepairDialog
        open={showAddRepairModal}
        subdivisionBuilderSupervisors={subdivisionBuilderSupervisors}
        theJob={theJob}
        onClose={() => setShowAddRepairModal(false)}
        onAdd={onAddRepair}
      />
      {showRepairModal && (
        <RepairDialog
          open
          isShowView={isShowView}
          subdivisionBuilderSupervisors={subdivisionBuilderSupervisors}
          repair={repair}
          theJob={theJob}
          handleClose={() => setShowRepairModal(false)}
          setJob={setJob}
          handleConfirm={refreshRepairs}
        />
      )}
      <MasterSheetRepairsCheckPhotos
        photos={photos}
        title={title}
        handleClose={() => setOpenCheckPhotosModal(false)}
        open={openCheckPhotosModal}
      />
      <EmailManagementDialog
        hasPhotos={hasPhotos}
        emailManagementOpen={emailManagementOpen}
        loadingBuilderSupervisorEmail={loadingBuilderSupervisorEmail}
        emailRepairId={emailRepairId}
        handleSendMail={handleSendMail}
        handleUploadClick={() => handleUploadClick(repair)}
        handleClose={() => {
          setEmailManagementOpen(false);
          setHasPhotos(false);
          setEmailRepairId(null);
        }}
      />
      <InfoDialog
        handleClose={() => setPoReleasedInfoOpen(false)}
        open={poReleasedInfoOpen}
        content="Contractor is not able to be assigned until the PO has been released."
      />
    </Box>
  );
};

export default DesktopRepairsView;
